/* eslint-disable no-param-reassign */
import { apiCall, updateSwaggerManager } from 'api';
import { buildRefreshTokenRequest, clearUserData, persistUserToken } from 'api/helpers/utils';
import { store } from '../../../../store';
import { setUserToken } from 'action-creators/user';
import { INVALID_FORMAT_TOKEN, INVALID_TOKEN } from '../errorCodes';

const invalidTokenCode = async error => {
  const refreshTokenResponse = await buildRefreshTokenRequest(error);
  const { data, errors } = refreshTokenResponse.data;

  if( errors?.[0]?.code === INVALID_FORMAT_TOKEN ||  errors?.[0]?.code === INVALID_TOKEN ) clearUserData();
  
  const { url, method, params } = error.config;

  persistUserToken(data?.user_token || data);
  updateSwaggerManager(apiCall, {
    user_token: data?.user_token || data,
  });
  store.dispatch(setUserToken(data?.user_token));

  const overridenParams = {
    ...params,
    user_token: data?.user_token || data,
  };

  const overridenHeaders = {
    Authorization: `Bearer ${data?.user_token || data}`,
    'user-token': data?.user_token || data,
  };

  const response = await apiCall({
    method,
    url,
    params: { ...overridenParams },
    headers: { ...overridenHeaders },
  });

  return response;
};

export default invalidTokenCode;
